export function productFilters() {
  const filterButtons = document.querySelectorAll(".products-filter__button");
  const productItems = document.querySelectorAll(".products-list__item");
  const filterStatus = document.getElementById("filter-status");
  const allButton = document.querySelector('[data-value="all"]');

  // Function to get filter button text for announcements
  function getFilterText(dataValue) {
    const button = document.querySelector(`[data-value="${dataValue}"]`);
    return button ? button.textContent.trim() : dataValue;
  }

  // Function to update filter announcements
  function updateFilterAnnouncement() {
    const visibleCount = Array.from(productItems).filter(
      (item) =>
        item.style.display !== "none" &&
        window.getComputedStyle(item).display !== "none"
    ).length;

    const totalCount = productItems.length;

    // Announce filter changes to screen readers
    const activeFilters = Array.from(filterButtons)
      .filter((button) => button.getAttribute("aria-pressed") === "true")
      .map((button) => getFilterText(button.getAttribute("data-value")));

    let announcement = "";
    if (activeFilters.length === 0) {
      announcement = `All filters cleared. Showing all ${totalCount} products.`;
    } else if (visibleCount === 0) {
      announcement = `No products match the selected filters: ${activeFilters.join(
        ", "
      )}.`;
    } else {
      announcement = `Filtered by ${activeFilters.join(
        ", "
      )}. Showing ${visibleCount} products.`;
    }

    if (filterStatus) {
      filterStatus.textContent = announcement;
    }
  }

  // Function to show/hide products based on active filters
  function filterProducts() {
    // Get all pressed filter buttons (excluding "all" button)
    const pressedFilters = Array.from(filterButtons)
      .filter(
        (button) =>
          button.getAttribute("aria-pressed") === "true" &&
          button.getAttribute("data-value") !== "all"
      )
      .map((button) => button.getAttribute("data-value"));

    // Check if "all" button is active or no specific filters are active
    const allActive =
      allButton && allButton.getAttribute("aria-pressed") === "true";
    const showAll = allActive || pressedFilters.length === 0;

    // Show/hide products based on filters
    productItems.forEach((item) => {
      if (showAll) {
        // Show all products
        item.style.display = "block";
        item.removeAttribute("aria-hidden");
      } else {
        // Check if item matches any active filter
        const productType = item.getAttribute("data-product-type");
        if (pressedFilters.includes(productType)) {
          item.style.display = "block";
          item.removeAttribute("aria-hidden");
        } else {
          item.style.display = "none";
          item.setAttribute("aria-hidden", "true");
        }
      }
    });

    // Update visual and accessibility feedback
    updateFirstVisibleItemBorder();
    updateFilterAnnouncement();
  }

  // Function to update the top border for the first visible item
  function updateFirstVisibleItemBorder() {
    // Remove top border class from all items
    productItems.forEach((item) => {
      item.classList.remove("first-visible-item");
    });

    // Find the first visible item and add the top border class
    const firstVisibleItem = Array.from(productItems).find((item) => {
      return (
        item.style.display !== "none" &&
        window.getComputedStyle(item).display !== "none"
      );
    });

    if (firstVisibleItem) {
      firstVisibleItem.classList.add("first-visible-item");
    }
  }

  // Function to toggle filter button state
  function toggleFilter(button) {
    const currentState = button.getAttribute("aria-pressed");
    const newState = currentState === "true" ? "false" : "true";
    const isAllButton = button.getAttribute("data-value") === "all";

    // Handle "All" button logic
    if (isAllButton) {
      if (newState === "true") {
        // Activate "All" button and deactivate all others
        button.setAttribute("aria-pressed", "true");
        filterButtons.forEach((btn) => {
          if (btn !== button) {
            btn.setAttribute("aria-pressed", "false");
            btn.classList.remove("active");
            const filterName = getFilterText(btn.getAttribute("data-value"));
            btn.setAttribute(
              "aria-label",
              `${filterName} filter inactive. Press to activate.`
            );
          }
        });
      } else {
        // Deactivate "All" button
        button.setAttribute("aria-pressed", "false");
      }
    } else {
      // Handle specific filter buttons
      if (newState === "true") {
        // Deactivate "All" button when any specific filter is activated
        if (allButton) {
          allButton.setAttribute("aria-pressed", "false");
          allButton.classList.remove("active");
          const allFilterName = getFilterText("all");
          allButton.setAttribute(
            "aria-label",
            `${allFilterName} filter inactive. Press to activate.`
          );
        }
      }
      button.setAttribute("aria-pressed", newState);
    }

    // Update button appearance and accessibility
    const filterName = getFilterText(button.getAttribute("data-value"));
    if (button.getAttribute("aria-pressed") === "true") {
      button.classList.add("active");
      button.setAttribute(
        "aria-label",
        `${filterName} filter active. Press to deactivate.`
      );
    } else {
      button.classList.remove("active");
      button.setAttribute(
        "aria-label",
        `${filterName} filter inactive. Press to activate.`
      );
    }
  }

  // Event listeners for filter buttons
  filterButtons.forEach((button) => {
    // Set initial aria-label
    const filterName = getFilterText(button.getAttribute("data-value"));
    const isAllButton = button.getAttribute("data-value") === "all";

    // Set initial state - "All" button should be active by default
    if (isAllButton) {
      button.setAttribute("aria-pressed", "true");
      button.classList.add("active");
      button.setAttribute(
        "aria-label",
        `${filterName} filter active. Press to deactivate.`
      );
    } else {
      button.setAttribute("aria-pressed", "false");
      button.setAttribute(
        "aria-label",
        `${filterName} filter inactive. Press to activate.`
      );
    }

    button.addEventListener("click", function () {
      toggleFilter(button);
      filterProducts();
    });

    // Support keyboard navigation
    button.addEventListener("keydown", function (event) {
      if (
        event.key === "Enter" ||
        event.key === " " ||
        event.keyCode === 13 ||
        event.keyCode === 32
      ) {
        event.preventDefault();
        toggleFilter(button);
        filterProducts();
      }
    });
  });

  // Function to activate filter based on hash value
  function activateFilterFromHash(hash) {
    if (hash) {
      // Find if there's a filter button with matching data-value
      const matchingButton = document.querySelector(`[data-value="${hash}"]`);

      if (matchingButton) {
        // First, ensure all buttons are in their default state
        filterButtons.forEach((btn) => {
          btn.setAttribute("aria-pressed", "false");
          btn.classList.remove("active");
          const filterName = getFilterText(btn.getAttribute("data-value"));
          btn.setAttribute(
            "aria-label",
            `${filterName} filter inactive. Press to activate.`
          );
        });

        // Activate the matching button
        toggleFilter(matchingButton);
        filterProducts();

        return true; // Indicate that a filter was activated
      }
    }
    return false; // No filter was activated
  }

  // Function to handle URL hash changes
  function handleHashChange() {
    const hash = window.location.hash.substring(1);
    activateFilterFromHash(hash);
  }

  // Function to handle direct anchor link clicks (even without hash in URL)
  function handleAnchorClicks() {
    document.addEventListener("click", function (event) {
      const target = event.target.closest("a[id]");

      if (target) {
        const linkId = target.getAttribute("id");

        // Try to activate the corresponding filter using the link's ID
        if (activateFilterFromHash(linkId)) {
          // If we successfully activated a filter, we might want to prevent
          // default behavior to avoid jumping to elements with that ID
          // Comment out the next line if you want to allow normal hash navigation
          // event.preventDefault();
        }
      }
    });
  }

  // Listen for hash changes (when clicking anchor links that update URL)
  window.addEventListener("hashchange", handleHashChange);

  // Listen for direct anchor link clicks
  handleAnchorClicks();

  // Check for hash on initial page load
  window.addEventListener("DOMContentLoaded", handleHashChange);

  // Also check immediately in case DOMContentLoaded has already fired
  if (document.readyState === "loading") {
    // Document is still loading, DOMContentLoaded will fire
  } else {
    // Document has already loaded
    handleHashChange();
  }

  // Initialize
  filterProducts(); // This will set initial first item border
}
